/**
 * Utility functions for string operations
 */

/**
 * Safely converts a value to a string, handling null/undefined and zero values
 * @param value - The value to convert
 * @returns A string representation, empty string for null/undefined/zero values
 */
export const safeString = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  const str = String(value);
  return str === "0" || str === "0.00" ? "" : str;
};
